export default "__VITE_ASSET__Cr7QUksB__"